"use strict";

module.exports = function () {

    if (this.orderBy.column != this.opts.groupBy) {
        this.setOrder(this.opts.groupBy, true);
    } else {
        this.setOrder(this.opts.groupBy, !this.orderBy.ascending);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/toggle-group-direction.js
// module id = 1504
// module chunks = 0